
import Vue from 'vue';
import facebookSvg from '@/assets/images/svg/facebook.svg';
import instagramSvg from '@/assets/images/svg/instagram.svg';

export default Vue.extend({
  components: { facebookSvg, instagramSvg },
});
